"use strict";
// Import dinâmico = async boundary do Module Federation (permite eager: false).
// Não trocar por import estático.
import('./bootstrap');
